import { useEffect, useState } from "react";
import axios from "axios";
import { setAccessToken } from "../utils/auth/tokenStore";
import AuthLoader from "../components/globalloaders/AuthLoader";
import { toast } from 'react-toastify';

const AuthBootstrap = ({ children }) => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const bootstrap = async () => {
            try {
                const res = await axios.post(`${process.env.REACT_APP_URI}/auth/refresh`, {}, { withCredentials: true });
                setAccessToken(res.data.accessToken);
            } catch (err) {
                if (err.response?.data?.message !== "Refresh token missing") {
                    toast.error("Session verification failed!");
                }
            } finally {
                setReady(true);
            }
        };
        bootstrap();
    }, []);

    if (!ready) return <AuthLoader />;
    return children;
};

export default AuthBootstrap;